
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/providers/[slug]",
      function () {
        return require("private-next-pages/providers/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/providers/[slug]"])
      });
    }
  